import React from 'react';
import { DataInput } from '../../screens/Profile/data-input/DataInput';
import { ValidatedDataInputProps } from './ValidatedDataInput';
import { UserDataKeys } from '../../screens/Profile/UserDataKeys';
import { isFirstNameValid, ValidatorResponse } from './Validator';
import { ProfileEventTypes, ProfileUpComm } from '../../screens/Profile/ProfileData';

export const minLength = 2;
export const maxLength = 50;

export const TEST_ID = {
  MAIN: 'first-name-input'
};

export interface FirstNameInputProps extends ValidatedDataInputProps, ProfileUpComm {
  persistEvent?: boolean
}

export const FirstNameInput: React.FC<FirstNameInputProps> = props => {
  const { whenValidated, upComm } = props;

  if (upComm?.ctx?.overrides?.values?.[UserDataKeys.firstName]) {
    upComm?.sendMsg({
      type: ProfileEventTypes.dataInit,
      data: {
        key: UserDataKeys.firstName,
        value: upComm.ctx.overrides.values[UserDataKeys.firstName]
      }
    });
  }
  if (upComm?.ctx?.overrides?.hidden?.[UserDataKeys.firstName]) {
    return <React.Fragment></React.Fragment>;
  }
  
  return (
    <DataInput
      validator={async (value: string) => {
        const isValid: ValidatorResponse = isFirstNameValid(value);
        if (!isValid.response) {
          whenValidated?.(false);
          throw new Error(isValid.reason);
        }
        whenValidated?.(true);
      }}
      // Mark this as a guaranteed value (defaultProp) so that TS is happy
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      dataLabel={props.dataLabel!}
      defaultValue={upComm?.ctx?.overrides?.values[UserDataKeys.firstName]}
      {...props}
    />
  );
};

FirstNameInput.defaultProps = {
  dataLabel: 'First Name',
  name: UserDataKeys.firstName,
  testId: TEST_ID.MAIN,
  id: 'first-name-input',
  required: true,
  helperMessage: `${maxLength} characters allowed`,
  persistEvent: false,
  whenValidated: () => { return; }
};
